__turbopack_context__.v({
  "analystRatingSummaryContainer": "AnalystRatingSummary-module-scss-module__og783q__analystRatingSummaryContainer",
  "firmRecommendationsContainer": "AnalystRatingSummary-module-scss-module__og783q__firmRecommendationsContainer",
});
